import { msg } from '@lingui/core/macro';
import { useLingui } from '@lingui/react/macro';
import { CreateNotificationProps, Notification } from 'modules/core/domain/interfaces/supabase/notifications/types';
import { Pages } from 'modules/navigation/domain/enums/pages';
import React, { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Navigate, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useIsAdmin } from 'shared/hooks/use-is-admin';
import { useToastApiError } from 'shared/hooks/use-toast-api-error';

import { AppDispatch } from 'store/store';
import UDBreadcrumbs from 'ud-ui/components/breadcrumbs';
import { useMainLayout } from 'modules/app-shell/ui/layout/context';
import { createNotification } from 'modules/notifications/store/actions';
import NotificationForm from '../components/notification-form';

const CreateNotificationPage: React.FC = () => {
  const { t } = useLingui();
  const toastApiError = useToastApiError();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const isAdmin = useIsAdmin();
  const { setHeaderContent } = useMainLayout();

  const handleSubmit = useCallback(
    async (values: Partial<Notification>) => {
      try {
        await dispatch(createNotification(values as CreateNotificationProps)).unwrap();
        navigate(Pages.NOTIFICATIONS.INDEX);
        toast.success(t`Уведомление создано`);
      } catch (error) {
        toastApiError(error, msg`Не удалось создать уведомление`);
      }
    },
    [dispatch, navigate, t, toastApiError],
  );

  const handleCancel = useCallback(() => {
    navigate(Pages.NOTIFICATIONS.INDEX);
  }, [navigate]);

  const breadcrumbs = useMemo(() => {
    return [
      { label: 'Уведомления', to: Pages.NOTIFICATIONS.INDEX },
      { label: 'Создание уведомления', to: Pages.NOTIFICATIONS.CREATE },
    ];
  }, []);

  useEffect(() => {
    setHeaderContent(<UDBreadcrumbs breadcrumbs={breadcrumbs} />);
    return () => setHeaderContent(null);
  }, [breadcrumbs, setHeaderContent]);

  if (!isAdmin) {
    return <Navigate to={Pages.NOTIFICATIONS.INDEX} replace />;
  }

  return (
    <>
      <div className="w-full p-6 px-6" style={{ margin: '0 auto' }}>
        <NotificationForm onSubmit={handleSubmit} onCancel={handleCancel} />
      </div>
    </>
  );
};

export default CreateNotificationPage;
